import React, { Fragment } from 'react';
import Header from '../../components/Header/Header';
import Hero from '../../components/PortfolioHero/Hero';
import TeamSection from '../../components/TeamSection/TeamSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';

const PortfolioPage = () => {
    return (
        <Fragment>
            <div className='index_memecoin page_wrapper'>
                <Header />
                <main className="page_content">
                    <Hero />
                    <TeamSection />
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    )
};
export default PortfolioPage;